<opac-dialog
  #dialog
  size="small"
  [title]="'challenges.createChallenge' | translate"
  (opened)="updateInitialValue()"
  (closed)="closeModal()">
  <p class="subtitle">{{'challenges.dailyGoalText' | translate}}</p>

  <form [formGroup]="dailyChallengeFormGroup">
    <div>
      <span>{{ 'challenges.hours.text' | translate }}</span>
      <opac-select formControlName="hours">
        <opac-option *ngFor="let hour of hours" [value]="hour">{{ hour }}</opac-option>
      </opac-select>
    </div>

    <div>
      <span>{{ 'challenges.minutes.text' | translate}}</span>
      <opac-select formControlName="minutes">
        <opac-option *ngFor="let minute of minutes" [value]="minute">{{ minute }}</opac-option>
      </opac-select>
    </div>
  </form>

  <opac-button slot="actions" (click)="createChallenge()">
    {{ (initialValue() !== undefined ? 'button.update' : 'button.create') | translate }}
  </opac-button>
</opac-dialog>
